const initialState = [];

export default (state = initialState, action) => {
    switch (action.type) {
        case "LICENCE_APPLICATIONS_RETRIEVED":
            return action.data;

        default:
            return state;
    }
}
